import { render, staticRenderFns } from "./Scatter.vue?vue&type=template&id=13cac0f7&scoped=true"
import script from "./Scatter.vue?vue&type=script&lang=js"
export * from "./Scatter.vue?vue&type=script&lang=js"
import style0 from "./Scatter.vue?vue&type=style&index=0&id=13cac0f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cac0f7",
  null
  
)

export default component.exports